var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.293 2.293a3.828 3.828 0 1 1 5.414 5.414L8.501 20.914l-.05.05c-.245.245-.46.461-.718.63q-.34.225-.727.35c-.293.095-.597.128-.941.166l-.07.008-3.385.376a1 1 0 0 1-1.104-1.104l.376-3.384.008-.07c.038-.345.071-.649.166-.942a3 3 0 0 1 .35-.727c.17-.257.385-.473.63-.718l.05-.05zm4 1.414a1.83 1.83 0 0 0-2.586 0L4.501 16.914c-.323.322-.383.389-.426.454a1 1 0 0 0-.116.242c-.024.075-.039.163-.09.616l-.237 2.142 2.142-.238c.453-.05.542-.064.616-.089q.13-.041.242-.116c.066-.043.132-.103.455-.425L20.293 6.293a1.83 1.83 0 0 0 0-2.586",
    clipRule: "evenodd"
  })));
};
export default SvgEdit;